import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import bannerImg from "@/assets/team/team-banner.png";
import vectorImg from "@/assets/team/banner-vector.png";
import useLocale from "@/hooks/useLocale";

export default function TeamBanner() {
  const locale = useLocale();

  return (
    <div>
      <div className="md:px-2 2xl:px-11 mx-auto w-full relative">
        <img
          src={vectorImg ?? ""}
          alt="vector"
          className="absolute max-w-[690px] w-full max-h-[845px] h-full right-0 top-0 hidden lg:block"
        />
        <div className="w-full m-auto h-screen md:min-h-[550px] lg:min-h-[830px] relative flex justify-center items-center max-h-[780px]">
          <SourceFlowImage
            src={bannerImg ?? ""}
            size="1750x830"
            alt="banner"
            className="absolute top-0 h-full md:top-[-120px] object-cover w-full"
          />
          <h1 className="text-[40px]/[50px] sm:text-6xl lg:text-[100px]/[100px] text-white relative xl:absolute max-w-[877px] md:bottom-48 text-center xl:text-start xl:left-[42px]">
            <CustomSourceFlowText
              title="Our team makes magic happen."
              path="dynamic1.teams.text2"
              locale={locale}
            />
          </h1>
        </div>
      </div>
      <div className="container flex justify-center pt-10 md:pt-0">
        <p className="text-lg sm:text-xl/[35px] md:text-3xl/[42px] text-white max-w-[807px] w-full text-center 3xl:max-w-[70%]">
          <CustomSourceFlowText
            title="Meet our outstanding team of tech recruitment professionals. Each member of our team shares a passion for connecting top talent with leading companies, bringing a distinctive blend of expertise, dedication, and enthusiasm. From seasoned veterans with years of industry experience to bright newcomers brimming with fresh ideas, our diverse team is united by a shared objective: to provide unparalleled service and support to both clients and candidates."
            path="dynamic1.teams.text3"
            locale={locale}
          />
        </p>
      </div>
    </div>
  );
}
